/**
 * v-hasPermi 操作权限处理
 * Copyright (c) 2019 ruoyi
 */

import store from "@/store";

export default {
  update(el, binding, vnode) {
    const { value, arg: display = "block" } = binding;
    const all_permission = "*:*:*";
    var permissions = store.getters && store.getters.permissions;
    // 用roles里是否有admin判断是否为超级管理员
    if (store.getters.roles.includes("admin")) {
      permissions = ["*:*:*"];
    }
    if (value && value instanceof Array && value.length > 0) {
      const permissionFlag = value;

      const hasPermissions = permissions.some((permission) => {
        return (
          all_permission === permission || permissionFlag.includes(permission)
        );
      });

      el.style.display = hasPermissions ? display : "none";
    } else {
      throw new Error(`请设置操作权限标签值`);
    }
  },
};
